import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./stores/store";
import vuetify from "./plugins/vuetify";
import i18n from "@/plugins/i18n";
import VCalendar from "v-calendar";
import VGauge from "vgauge";
import * as VueGoogleMaps from "vue2-google-maps";
import VueCodemirror from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/monokai.css";
import "codemirror/addon/hint/javascript-hint.js";
import "codemirror/mode/javascript/javascript.js";
import VueFriendlyIframe from "vue-friendly-iframe";
import VueScrollTo from 'vue-scrollto'

Vue.component("vue-friendly-iframe", VueFriendlyIframe);

Vue.config.productionTip = false;

Vue.use(VGauge);

Vue.use(VueScrollTo)
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_API_KEY,
    plugins: "places,drawing,visualization"
  },
  installComponents: true
});

Vue.use(VueCodemirror, {
  options: {
    theme: "monokai",
    tabSize: 4,
    mode: "text/javascript",
    lineNumbers: true
  }
});

Vue.use(VCalendar, {
  componentPrefix: "vc"
});

new Vue({
  store,
  router,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
